import dbList from "../DBList.json";

const {
    api_server,
    clock_data_tag
} = dbList.server;

const url = api_server + clock_data_tag;

export async function GetClockDataTag() {
    const httpRes = await fetch(url, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (!httpRes.ok) {
        throw new Error(await httpRes.text());
    }

    return await httpRes.json();
}

export async function AddClockDataTag(AClockDataTag) {
    const httpRes = await fetch(url, {
        method: "PUT",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify(AClockDataTag)
    });

    if (!httpRes.ok) {
        throw new Error(await httpRes.text());
    }
}

export async function UpdateClockDataTag(AClockDataTag) {
    const httpRes = await fetch(url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify(AClockDataTag)
    });

    if (!httpRes.ok) {
        throw new Error(await httpRes.text());
    }
}

export async function DeleteClockDataTag(AId) {
    const httpRes = await fetch(`${ url }/${ AId }`, {
        method: "DELETE",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (!httpRes.ok) {
        throw new Error(await httpRes.text());
    }
}